"use client";

import React, { useState } from "react";
import { PrismicRichText } from "@prismicio/react";
import line from "../assets/titileline.png";
import { PrismicNextImage, PrismicNextLink } from "@prismicio/next";
import Image from "next/image";

const Member = ({ image, name, desgination, colorImage, link }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <PrismicNextLink field={link}>
      <div
        className="max-w-[230px] mx-auto lg:max-w-[296px] single-card-shadow group"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <div className="relative bg-transparent">
          <PrismicNextImage
            fallbackAlt={""}
            field={colorImage}
            loading={"lazy"}
            className={`absolute   inset-0 max-w-[230px] lg:max-w-[296px] transition-opacity duration-700 ease-in-out ${isHovered ? "opacity-100" : "opacity-0"}`}
          />
          <PrismicNextImage
            fallbackAlt={""}
            field={image}
            loading={"lazy"}
            className={`inset-0 max-w-[230px] lg:max-w-[296px] transition-opacity duration-700 ease-in-out ${isHovered ? "opacity-0" : "opacity-100"}`}
          />
        </div>

        {/* <PrismicNextImage
        fallbackAlt={""}
        field={isHovered ? colorImage : image}
        loading={"eager"}
        className="max-w-[230px] lg:max-w-[296px] transition-opacity duration-500 ease-in-out delay-200 "
      /> */}
        <div className="py-[16px] px-[16px] bg-[white] flex flex-col gap-[4px] h-[78px] md:h-[82px]">
          <div className="name_wrap gap-[11px] lg:gap-[14px] flex items-center">
            <div className="max-w-[27px] lg:w-[35px]">
              <Image src={line} className="block w-[100%]" alt="line" />
            </div>

            <PrismicRichText
              field={name}
              components={{
                heading2: ({ children }) => (
                  <h2 className="text-medium title-font text-[#ffffff]">
                    {children}
                  </h2>
                ),
                heading6: ({ children }) => (
                  <h6 className="text-medium title-font text-[#ffffff]">
                    {children}
                  </h6>
                ),
                paragraph: ({ children }) => (
                  <p className="title-font text-medium text-[#232629] title-large">
                    {children}
                  </p>
                ),
              }}
            />
          </div>
          <div>
            <PrismicRichText
              field={desgination}
              components={{
                paragraph: ({ children }) => (
                  <p className="text-caption text-[#717171] font-normal pl-[38px] lg:pl-[42px]">
                    {children}
                  </p>
                ),
              }}
            />
          </div>
        </div>
      </div>
    </PrismicNextLink>
  );
};

export default Member;
